import { render } from "./DynamicMenuItem.vue?vue&type=template&id=06bab5ff&scoped=true"
import script from "./DynamicMenuItem.vue?vue&type=script&lang=js"
export * from "./DynamicMenuItem.vue?vue&type=script&lang=js"

import "./DynamicMenuItem.vue?vue&type=style&index=0&id=06bab5ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06bab5ff"]])

export default __exports__